/**
 * Componente de sección de filtros para estadísticas por producto
 * Filters section component for product statistics
 */
import { Search } from '@shared/components/ui/Search';
import { ChangeEvent, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ColumnSelector } from '@shared/components/ui/ColumnSelector';
import { ColumnDef } from '@tanstack/react-table';

interface FiltersSectionProps {
  handleSearch: (value: string) => void;
  columns: ColumnDef<any>[];
  selectedColumns: string[];
  onColumnsChange: (newSelected: string[]) => void;
  searchTerm: string;
}

export const FiltersSection = ({
  handleSearch,
  columns,
  selectedColumns,
  onColumnsChange,
  searchTerm,
}: FiltersSectionProps) => {
  const { t } = useTranslation('logisticsModule');
  // 🎯 Estado local - NO causa re-render del componente padre
  // Local state - Does NOT cause parent component re-render
  const [inputValue, setInputValue] = useState(searchTerm);

  useEffect(() => {
    setInputValue((prev) => (prev === searchTerm ? prev : searchTerm));
  }, [searchTerm]);

  // 🎯 Handler para el cambio del input - Solo afecta al estado local
  // Handler for input change - Only affects local state
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  // 🎯 Handler para ejecutar búsqueda - comunica al padre el filtro estructurado
  // Handler to execute search - communicates structured filter to parent
  const handleSearchSubmit = () => {
    handleSearch(inputValue.trim());
  };

  return (
    <>
      <Search
        placeholder={t('product_statistics.search_placeholder')}
        value={inputValue}
        onChange={handleInputChange}
        onEnter={handleSearchSubmit}
        dataTestId="product-statistics-search"
        inputDataTestId="product-statistics-search-input"
      />
      <ColumnSelector
        columns={columns}
        selected={selectedColumns}
        onColumnsChange={onColumnsChange}
        storageKey="logistics-product-statistics-table"
      />
    </>
  );
};
